import { BrowserRouter,Routes,Route } from 'react-router-dom';
import './App.css';
import Home from "./pages/home/Home"
import Project from './pages/project/Project';
import Service from './pages/service/Service';


function App() {
  return (
    <div className="App">
    <BrowserRouter>
    <Routes>
       <Route path='/' element={<Home/>}/>
       <Route path='/services/:id' element={<Service/>}/>
       <Route path='projects/:id'  element={<Project/>}/>
    </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
